import { ExclamationCircleFilled } from '@ant-design/icons'
import { Vertical, Horizontal, Texto } from '@gravitate-js/excalibrr'
import type { ICellRendererParams } from 'ag-grid-community'
import { Popover } from 'antd'

export function TransactionErrorCellRenderer(params: ICellRendererParams) {
  if (!params.data.error && !params.data.errors) return null

  let errorLst = params.data.error || params.data.errors
  if (!params.data.errors) {
    errorLst = [params.data.error]
  }

  return (
    <Popover
      trigger={'hover'}
      styles={{ root: { width: 'auto', maxWidth: '350px' } }}
      content={
        <Vertical gap={4}>
          {errorLst.map((e) => (
            <Vertical key={e.type} gap={2}>
              <Horizontal verticalCenter gap={8}>
                <ExclamationCircleFilled style={{ color: 'var(--theme-error)' }} />
                <Texto weight={'bold'}>{e.type}</Texto>
              </Horizontal>
              {e.message && <Texto className='pl-4'>{e.message}</Texto>}
            </Vertical>
          ))}
        </Vertical>
      }
    >
      <div>
        <Vertical gap={2}>
          {errorLst.map((e) => (
            <Horizontal key={e.type} verticalCenter gap={4}>
              <ExclamationCircleFilled style={{ color: 'var(--theme-error)' }} /> <Texto>{e.type}</Texto>
            </Horizontal>
          ))}
        </Vertical>
      </div>
    </Popover>
  )
}
